import { useDispatch, useSelector } from 'react-redux';
import style from './index.module.scss';
import { getWorksFields } from 'system-redux-sagas/actions';
import { useEffect } from 'react';
import { LoadingOutlined } from '@ant-design/icons';
import { useAuth } from 'hooks/useAuth';

type TGridWorksFields = {
  onClick: (id: string) => void;
  selected: string[];
};

export const GridOfWorksFields = ({ onClick, selected }: TGridWorksFields) => {
  const { getToken } = useAuth();
  const dispatch = useDispatch();
  const { worksFields, loading } = useSelector((state: any) => state.system);

  useEffect(() => {
    (async () => {
      await getToken(true);
      dispatch(getWorksFields());
    })();
  }, [dispatch, getToken]);

  return (
    <div className={style.grid}>
      {(!loading &&
        worksFields
          ?.filter(({ name }: any) => !!name)
          .map(({ id, name, imageURL }: any) => (
            <div
              className={`${style.avatar} ${
                selected.includes(id) ? style.selected : ''
              }`}
              onClick={() => onClick(id)}
              key={id}
            >
              <div className={style.imgContent}>
                <div
                  className={style.img}
                  style={{ backgroundImage: `url(${imageURL})` }}
                />
              </div>
              <p>{name}</p>
            </div>
          ))) || <LoadingOutlined />}
    </div>
  );
};
